import NavBar from 'views/components/common/NavBar/NavBar';

export default NavBar;
